import { Skill } from "@/modules/types/metadata/metadata";
import { useCallback, useState } from "react";
import debounce from "lodash/debounce";
import { metadataService } from "@/modules/services/metadataService";
import { AppError } from "@/lib/utils/errors";

export const useSearchSkills = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [skillSuggestions, setSkillSuggestions] = useState<Skill[]>([]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    setSearchTerm(event.target.value);
    fetchSkillSuggestions(event.target.value);
  };

  const fetchSkillSuggestions = useCallback(
    debounce(async (name: string) => {
      try {
        const resp = await metadataService.getSkills({
          name,
          limit: 7, // You can adjust this limit as needed
        });

        if (resp && resp.skills) {
          setSkillSuggestions(resp.skills);
        }
      } catch (err) {
        const appErr = new AppError(err);
        appErr.setAction("useSearchSkills.fetchSkillSuggestions");
        appErr.setApiAction("metadataService.getSkills");
        appErr.logError();
      } finally {
        setLoading(false);
      }
    }, 1300),
    []
  );

  return {
    searchSkillsTerm: searchTerm,
    handleSearchSkills: handleSearch,
    skillSuggestions,
    loadingSkillSuggestions: loading,
  };
};
